import styled from "styled-components";
import Dialog from "@material-ui/core/Dialog";

const ModalContainer = styled(Dialog)`
  text-align: center;
  .MuiDialog-paper {
    margin: 15px;
  }
  p {
    font-size: 20px;
  }
  button {
    color: #fff;
    background: ${(props) => props.theme.colors.primary.main};
    transition: all 0.6s ease 0s;
    width: 100px;
    height: 30px;
    margin-top: 20px;
    border: 0;
    &:hover {
      background: #000;
    }
  }
`;

export default ModalContainer;
